mutation CompanyCorporateYearCreate($input: CompanyCorporateYearCreateInput!) {
  companyCorporateYearCreate(input: $input) {
    companyCorporateYear {
      id
      fiscalYear
      startDate
      endDate
      isYearOpen
      isEntryAllowed
      _rowTimestamp
      _isUpdatable
      _isDeletable
      companyCorporatePeriodsByFiscalYearId(orderBy: FISCAL_PERIOD_ASC) {
        totalCount
      }
    }
  }
}
